// ** MUI Imports
import Box from '@mui/material/Box'

// ** Config Import
import themeConfig from 'src/configs/themeConfig'

// ** Menu Components
import HorizontalNavItems from './HorizontalNavItems'

const Navigation = props => {
  return (
    <Box
      className='menu-content'
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        '& > *': {
          '&:not(:last-child)': { mr: 4 },
          ...(themeConfig.menuTextTruncate && { maxWidth: 220 })
        },
        '@media (max-width: 1600px)': {
          '& > *': {
            '&:not(:last-child)': { mr: 1.5 }
          }
        }
      }}
    >
      <HorizontalNavItems {...props} />
    </Box>
  )
}

export default Navigation
